import { defineMessages, IntlShape } from "react-intl";

import { getDisplayName } from "@app/util/ui/getDisplayName";

import PermissionStatus from "../enum/PermissionStatus";

const messages = defineMessages<PermissionStatus>({
  [PermissionStatus.DENIED]: {
    id: "reports.permissionsReport.permissionStatus.denied",
    defaultMessage: "Off",
    description: "A permission the rep has turned off",
  },
  [PermissionStatus.GRANTED]: {
    id: "reports.permissionsReport.permissionStatus.granted",
    defaultMessage: "On",
    description: "A permission the rep has granted",
  },
  [PermissionStatus.MIXED]: {
    id: "reports.permissionsReport.permissionStatus.mixed",
    defaultMessage: "Mixed",
    description: "A permission whose value differs between a rep's devices",
  },
  [PermissionStatus.NOT_APPLICABLE]: {
    id: "reports.permissionsReport.permissionStatus.notApplicable",
    defaultMessage: "N/A",
    description: "A permission that does not apply to the rep",
  },
  [PermissionStatus.UNKNOWN]: {
    id: "reports.permissionsReport.permissionStatus.unknown",
    defaultMessage: "Unknown",
    description: "A permission the rep's device has never reported",
  },
});

const getPermissionStatusDisplayName = (intl: IntlShape, status: PermissionStatus) =>
  getDisplayName(intl, messages, status, "PermissionStatus");

export default getPermissionStatusDisplayName;
